import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { once } from '@ember/runloop';

import themed from 'webapp/decorators/themed';
import didUpdate from 'webapp/modifiers/did-update';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args as BaseArgs } from 'webapp/components/form/range/inline';
import FormRangeInlineComponent from 'webapp/components/form/range/inline';

import type DateRange from 'webapp/models-custom/date-range';
import type DsCompare from 'webapp/models-custom/ds-compare';

interface Args extends BaseArgs {
	hasSelection: boolean;
	onChange: (
		dateRange: DateRange | null,
		compare?: DsCompare | null,
		applyToWholeLoop?: boolean,
	) => void;
	customLabel?: string;
}

@themed()
export default class FormRangeNullableComponent extends FormRangeInlineComponent<Args> {
	get canClear() {
		return false; // for now always false
	}

	override get labelText() {
		return this.args.customLabel || 'Date range';
	}

	@action
	clearRange(e: PointerEvent) {
		e.stopPropagation();
		this.args.onChange(null, null);
	}

	@action
	scheduleUpdateDateRange() {
		let dateRange, compare;

		if (this.args.metricLimitations.dateRange?.isEmpty) {
			dateRange = null;
		} else {
			dateRange = this.args.metricLimitations.dateRange;
		}

		if (this.args.metricLimitations.compare) {
			compare = null;
		} else {
			compare = this.args.metricLimitations.compare!;
		}

		once(this, this.args.onChange, dateRange, compare);
	}
	<template>
		<div
			class="cdr-range-inline nullable
				{{if @isDisabled 'disabled'}}
				{{this.themeClass}}
				{{this.sizeClass}}"
		>
			<a
				class="range-selector {{if @hasSelection 'em'}} {{if this.canClear 'has-clear'}}"
				{{on "click" this.openDropdown}}
				{{didUpdate this.scheduleUpdateDateRange @metricLimitations.dateRange.rangeFormula}}
			>
				<span class="range-label">
					<CommonUiIconComponent @name="Calendar" @size="dynamic" />
					{{#if @hasSelection}}
						{{this.dateRange.rangeTitleUX}}
						{{#if this.canClear}}
							<a class="clear-range" {{on "click" this.clearRange}}>
								<CommonUiIconComponent @name="Close" @size="dynamic" />
							</a>
						{{/if}}
					{{else}}
						{{this.labelText}}
					{{/if}}
				</span>
			</a>
		</div>
	</template>
}
